import { Typography } from '../../../atoms/typography/typography';
import { ReactNode } from 'react';

type NameProps = {
  icon: ReactNode;
  title: string;
  subTitle?: string;
};

export function Activity(props: NameProps) {
  const { title, subTitle, icon } = props;

  return (
    <div className="flex items-center gap-x-12">
      {icon}

      <div className="flex flex-col">
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale600"
        >
          {title}
        </Typography>

        {subTitle && (
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale300 ellipsis overflow-hidden text-nowrap"
          >
            {subTitle}
          </Typography>
        )}
      </div>
    </div>
  );
}
